import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler, XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {recategorizationList_template} from "../components/templates/recategorizationList_template";
import {header} from "./header";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class recategorization extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected recategorizationList: recategorizationList_template;

    buildContent(): Array<Element> {
        this.recategorizationList = new recategorizationList_template("recategorizationList", this.viewModel, this)
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Recategorization Tool");
        return [this.recategorizationList.build()];
    }

    protected getModuleName(): string {
        return "recategorization";
    }

    fillPage() {
        this.getRecategorizationData(0);
    }

    protected getRecategorizationData(section) {

        // LOADING : starts
        this.loadTable(section, 1);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(this.recategorizationList.getViewModelForRequest())]);
        params.push(["section", section]);

        let url: string = '/api/brand/' + idBrand + "/recategorization-tool/get/";

        this.XHRHdl = new XMLHttpRequestHandler(url, params, this);

        this.XHRHdl.onReadyStateFunction = this.ongetRecategorizationDataReturn;
        this.XHRHdl.execute();
    }

    protected ongetRecategorizationDataReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);

                let section = responseParsed.section;
                obj.loadTable(section, 0);
            });
        }
    }

    protected recategorizationsListReorder(section) {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
            this.loadTable(0, 0);
        }

        this.getRecategorizationData(section);
    }

    protected paginationOnPageClick(idElement) {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
            this.loadTable(0, 0);
        }
        let section = null;
        switch(idElement){
            case 'paginationCurrentTags':
                section = 1;
                break;
            case 'paginationTargetTags':
                section = 2;
                break;
            case 'paginationCurrentCategories':
                section = 3;
                break;
            case 'paginationTargetCategories':
                section = 4;
                break;
            case 'pagination':
                section = 5;
                break;
        }
        this.getRecategorizationData(section);
    }

    protected filterSimpleOnChange(idElement) {

        this.filterList(idElement);
    }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
            this.loadTable(0, 0);
        }
    }

    protected filterList(idElement){

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
            this.loadTable(0, 0);
        }

        let section = null;
        switch(idElement){
            case 'filterCurrentTag':
                section = 1;
                break;
            case 'filterTargetTag':
                section = 2;
                break;
            case 'filterCurrentCategory':
                section = 3;
                break;
            case 'filterTargetCategory':
                section = 4;
                break;
        }

        // LOADING : starts
        this.loadTable(section, 1);

        let recategorizationReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/recategorization-tool/get/';
        let recategorizationReq_params: Array<Array<string>> = [];
        recategorizationReq_params.push(["data", ko.toJSON(this.recategorizationList.getViewModelForRequest())] );
        recategorizationReq_params.push(["section", section]);
        this.XHRHdl = new XMLHttpRequestHandler(recategorizationReq_url,recategorizationReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){
        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);

                let section = responseParsed.section;
                obj.loadTable(section, 0);
            });

        }
    }

    protected updateList(responseParsed: any){

        let totalCount = responseParsed.recategorizations.totalCount;
        let totalPage = responseParsed.recategorizations.totalPage;
        let recategorizations = responseParsed.recategorizations.data;

        let currentTagTotalCount = responseParsed.currentTags.totalCount;
        let currentTagTotalPage = responseParsed.currentTags.totalPage;
        let currentTags = responseParsed.currentTags.data;

        let targetTagTotalCount = responseParsed.targetTags.totalCount;
        let targetTagTotalPage = responseParsed.targetTags.totalPage;
        let targetTags = responseParsed.targetTags.data;

        let currentCategoryTotalCount = responseParsed.currentCategories.totalCount;
        let currentCategoryTotalPage = responseParsed.currentCategories.totalPage;
        let currentCategories = responseParsed.currentCategories.data;

        let targetCategoryTotalCount = responseParsed.targetCategories.totalCount;
        let targetCategoryTotalPage = responseParsed.targetCategories.totalPage;
        let targetCategories = responseParsed.targetCategories.data;

        let currentTagsToSet = [];
        let targetTagsToSet = [];
        let currentCategoriesToSet = [];
        let targetCategoriesToSet = [];

        for (let item of recategorizations) {
            if(item.status == "In Progress") {
                item.statusClass = "in-progress icon i-inprogress"
            }
            else if(item.status == "Done") {
                item.statusClass = "done icon i-check"
            }
            else if(item.status == "Error") {
                item.statusClass = "error icon i-error"
            }
            else {
                item.statusClass = "pending icon i-hourglass"
            }
        }

        for (let item of currentTags) {
            currentTagsToSet.push( {
                id: item.id
                ,name: item.name
                ,type: (item.type && item.type.name) ? `${item.type.name} ${item.type.formattedDataset}` : ''
                ,articleCount: (item.details && item.details.articleCount) ? item.details.articleCount : '0'
                ,isSelectable: (item.details && item.details.isSelectable) ? true : false
                ,isLogged: (item.isLogged) ? true : false
            } )
        }

        for (let item of targetTags) {
            targetTagsToSet.push( {
                id: item.id
                ,name: item.name
                ,type: (item.type && item.type.name) ? `${item.type.name} ${item.type.formattedDataset}` : ''
                ,articleCount: (item.details && item.details.articleCount) ? item.details.articleCount : '0'
                ,isSelectable: (item.details && item.details.isSelectable) ? true : false
                ,isLogged: (item.isLogged) ? true : false
            } )
        }

        for (let item of currentCategories) {
            currentCategoriesToSet.push( {
                id: item.id
                ,name: item.name
                ,articleCount: (item.details && item.details.articleCount) ? item.details.articleCount : '0'
                ,isSelectable: (item.details && item.details.isSelectable) ? true : false
                ,isLogged: (item.isLogged) ? true : false
            } )
        }

        for (let item of targetCategories) {
            targetCategoriesToSet.push( {
                id: item.id
                ,name: item.name
                ,articleCount: (item.details && item.details.articleCount) ? item.details.articleCount : '0'
                ,isSelectable: (item.details && item.details.isSelectable) ? true : false
                ,isLogged: (item.isLogged) ? true : false
            } )
        }

        // set the lists
        this.recategorizationList.setCurrentTags(currentTagsToSet);
        this.recategorizationList.setTargetTags(targetTagsToSet);
        this.recategorizationList.setCurrentCategories(currentCategoriesToSet);
        this.recategorizationList.setTargetCategories(targetCategoriesToSet);
        this.recategorizationList.setRecategorizations(recategorizations);

        let execTime = Math.round((new Date().getTime() - this.XHRHdl.requestStartTime)/1000*100)/100;
        this.recategorizationList.setResultInfoCurrentTags(currentTagTotalCount, currentTagTotalPage, execTime);
        this.recategorizationList.setResultInfoTargetTags(targetTagTotalCount, targetTagTotalPage, execTime);
        this.recategorizationList.setResultInfoCurrentCategories(currentCategoryTotalCount, currentCategoryTotalPage, execTime);
        this.recategorizationList.setResultInfoTargetCategories(targetCategoryTotalCount, targetCategoryTotalPage, execTime);
        this.recategorizationList.setResultInfo(totalCount, totalPage, execTime);

        // update the paginators
        this.viewModel.recategorizationList.paginationCurrentTags.itemCount(currentTagTotalCount);
        this.viewModel.recategorizationList.paginationTargetTags.itemCount(targetTagTotalCount);
        this.viewModel.recategorizationList.paginationCurrentCategories.itemCount(currentCategoryTotalCount);
        this.viewModel.recategorizationList.paginationTargetCategories.itemCount(targetCategoryTotalCount);
        this.viewModel.recategorizationList.pagination.itemCount(totalCount);
    }

    protected deleteRecategorization(data) {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
            this.loadTable(0, 0);
        }
        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let formReq_url = "/api/brand/" + idBrand + "/recategorization-tool/delete/" + data.id + "/"
        let formReq_params: Array<Array<string>> = [];

        // LOADING : starts
        this.loadTable(5, 1);
        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {
                    obj.getVnAppZone().notification =
                        new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS,
                            "Recategorization task was successfully deleted");
                    obj.getVnAppZone().showNotificationToModule()
                    obj.getRecategorizationData(null)
                })

                obj.loadTable(5, 0);
            }
        });
        XHRHdl.execute();
    }

    protected confirmRecategorization() {

        // LOADING : starts
        this.loadTable(5, 1);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let formReq_url: string = '/api/brand/' + idBrand + "/recategorization-tool/save/";
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.viewModel));

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    let idBrand = obj.getVnAppZone().getApp().params.idBrand;
                    let params: Array<Array<string>> = [];
                    params.push(["data", ko.toJSON(obj.recategorizationList.getViewModelForRequest())]);
                    params.push(["section", null]);

                    let url: string = '/api/brand/' + idBrand + "/recategorization-tool/get/";

                    obj.XHRHdl = new XMLHttpRequestHandler(url, params, obj);
                    obj.XHRHdl.onReadyStateFunction = obj.ongetRecategorizationDataReturn;
                    obj.XHRHdl.execute();

                    if (req.request.status === 200) {
                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Recategorization saved !");
                        obj.getVnAppZone().showNotificationToModule();
                    }
                });
                obj.recategorizationList.clearSelections();
                obj.loadTable(5, 0);
            }
        });
        XHRHdl.execute();
    }

    protected getRecategorizationPreview() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
            this.loadTable(0, 0);
        }

        let idCurrentTag = this.recategorizationList.getTemplateViewModel().idCurrentTag();
        let idCurrentCategory = this.recategorizationList.getTemplateViewModel().idCurrentCategory();
        let idTargetTag = this.recategorizationList.getTemplateViewModel().idTargetTag();
        let idTargetCategory = this.recategorizationList.getTemplateViewModel().idTargetCategory();
        let subViewModel = {idCurrentTag: idCurrentTag,  idCurrentCategory: idCurrentCategory, idTargetTag: idTargetTag, idTargetCategory: idTargetCategory};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/recategorization-tool/preview/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.onReadyStateFunction = this.onGetPreviewReturn;
        this.XHRHdl.execute();
    }

    protected onGetPreviewReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function(){
                let response = JSON.parse(req.request.response);
                obj.recategorizationList.setAffectedArticles(response.data.affectedArticles);
                obj.recategorizationList.setAffectedListingPages(response.data.affectedListingPages);
                obj.recategorizationList.setAffectedDeletedListingPage(response.data.affectedDeletedListingPage);
                obj.recategorizationList.setAffectedConflictedListingPage(response.data.affectedConflictedListingPage);
            });
        }
    }

    protected loadTable(section, flag){
        switch (section){
            case 0:
                this.recategorizationList.isCurrentTagsLoading(flag);
                this.recategorizationList.isTargetTagsLoading(flag);
                this.recategorizationList.isCurrentCategoriesLoading(flag);
                this.recategorizationList.isTargetCategoriesLoading(flag);
                this.recategorizationList.isRecategorizationLoading(flag);
                break;
            case 1:
                this.recategorizationList.isCurrentTagsLoading(flag);
                break;
            case 2:
                this.recategorizationList.isTargetTagsLoading(flag);
                break;
            case 3:
                this.recategorizationList.isCurrentCategoriesLoading(flag);
                break;
            case 4:
                this.recategorizationList.isTargetCategoriesLoading(flag);
                break;
            case 5:
                this.recategorizationList.isRecategorizationLoading(flag);
                break;
        }
    }
}


// WEBPACK FOOTER //
// ./js/modules/recategorization.ts